import { Checkbox, Label } from "flowbite-react"

type CustomProps = {
  id?: number
  name?: string
  value: string
  defaultChecked?: boolean | undefined
  handleClick?: (e: any, id: number | undefined) => void
  SocialIcon?: React.ReactNode
  label?: string
  radioKey?: string
  isSelected?: number
  disabled?: boolean
  className?: string
  description?: string
  descriptionClassName?: string
}

const InputRadio = ({
  id,
  name,
  value,
  handleClick,
  label,
  radioKey,
  isSelected,
  disabled,
  className,
  description,
  descriptionClassName = "",
}: CustomProps) => {
  return (
    <div
      className={`select-source-block lg:m-2 m-1 lg:my-6 my-3 items-center rounded-md border ${className ?? ""} ${
        isSelected === id ? "border-primary-600" : "border-neutral-200"
      }`}
      onClick={(e) => handleClick?.(e, id)}
    >
      <Checkbox
        id={radioKey}
        name={name}
        value={value}
        disabled={disabled && name === "seasonType"}
        checked={isSelected === id}
        onChange={(e) => handleClick?.(e, id)}
        className={`h-4 w-4 rounded-xl`}
      />
      <Label
        htmlFor={radioKey}
        className={`flex h-full lg:p-4 p-3 !rounded-md  ${
          disabled && name === "seasonType" ? "!bg-neutral-100" : ""
        } ${isSelected === id ? "border-primary-600 bg-primary-50" : "bg-neutral-50"}`}
      >
        <div
          className={`${
            disabled && name === "seasonType" ? "!text-neutral-400" : ""
          } lg:text14Semibold text12Semibold font-semibold tracking-wide`}
        >
          {label}
          {description ? <div className={descriptionClassName}>{description}</div> : null}
        </div>
      </Label>
    </div>
  )
}

export default InputRadio
